





















































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  orderProcessingDetailed,
  orderProcessingSuccess,
  orderUploadExcel,
  orderOutExcel,
  createdStockoutOrder,
  orderProcessingList,
} from '@/utils/api';
import tableEmpty from '@/components/empty/tableEmpty.vue';

import DialogUpload from '@/components/dialogUpload.vue';

@Component({ components: { tableEmpty, DialogUpload } })
export default class OrderProcessing extends Vue {
  outOfStockLoading = false;
  currentPage = 1;
  pagesize = 20;
  businessType = 0;
  totalElements = 0;
  deliveryDrawer = false;
  outStockDrawer = false;
  logisticsInfoType = '0';//单选选择哪个
  dataList: any[] = [];
  //详情数据 抽屉
  detailed: any = {};
  detailed1: any = {};
  //订单编号
  orderId = '';
  // sku 列表
  skuSendNumList: any[] = [];
  skuSendNumList1: any[] = [];
  // 发货提交表单
  commitForm: any = {
    companyCode: '',
    companyName: '',
    num: '',
    orderId: '',
    skuSendNumList: [],
  };
  timeId: any = ''; //防抖
  // 缺货提交表单
  commitForm1: any = {
    orderId: '',
    skuSendNumList: [],
  };
  // 初始化表单
  form: object = {
    companyCode: 0,
    companyName: '',
    num: '',
    orderId: '',
    skuSendNumList: []
  };
  form1: object = {
    orderId: '',
    skuSendNumList: [],
  };
  data: any = {
    page: 0,
    size: this.pagesize,
    orderId: '',
  };
  loading = true;
  loadingButton = false;
  // message 提示
  alertStatus = false;

  // 批量发货
  uploadUrl: string =
    process.env.NODE_ENV === 'development'
      ? `/bff-supplier/supplier/deliver/order/import/excel`
      : `${location.origin}/api/bff-supplier/supplier/deliver/order/import/excel`;
  batchShipmentVisible = false;
  warningList: Array<string> = [
    '1. 请下载最新批量发货模板，以免出错',
    '2. 请按照模板中字段顺序及要求填写数据',
    '3. 单个文件中最多填写1000行商品数据，超出无法导入',
    '4. 若导入失败，可在导入结果中查看失败原因，按要求修改后重新上传导入',
  ];
  mounted() {
    this.getList(this.data);
  }

  // 重置
  resetSearch() {
    this.data.orderId = '';
  }
  //获取列表
  async getList(data) {
    try {
      this.loading = true;
      const result = await orderProcessingList(data);
      if (result) {
        this.dataList = result['content'];
        this.totalElements = result['totalElements'];
        this.loading = false;
      }
    } catch (error) {
      this.$message.error(error);
      this.loading = false;
    }
  }
  //获取详情
  async getDetailed(orderId) {
    try {
      const result = await orderProcessingDetailed(orderId);
      this.detailed = result;
      this.businessType = result.businessType || 0;
      this.skuSendNumList = (this as any).detailed.orderSkus.map((item: any) => {
        item.nowNum = item.undeliveredNum;
        return item;
      });
    } catch (error) {
      this.$message.error(error);
      this.loading = false;
    }
  }
  //分页
  async handleCurrentChange(val) {
    try {
      this.data['page'] = val - 1;
      await this.getList(this.data);
    } catch (error) {}
  }
  // 查看详情 跳转订单详情
  handleClick1(row) {
    this.$router.push(`detailed?orderId=${row.orderId}`);
  }
  //发货抽屉打开
  handleClick2(row) {
    this.orderId = row.orderId.toString();
    this.getDetailed(this.orderId);
    this.deliveryDrawer = true;
  }
  // 跳转缺货详情
  handleClick3(row) {
    this.outOfStockLoading = false;
    this.outStockDrawer = true;
    this.orderId = row.orderId.toString();

    orderProcessingDetailed(this.orderId)
      .then((res) => {
        this.detailed1 = res;
        this.skuSendNumList1 = (this as any).detailed1.orderSkus.map((item: any) => {
          item.stockoutNum = item.undeliveredNum;
          return item;
        });
      })
      .catch((error) => {
        this.$message.error(error);
      });
  }
  // 缺货商品删除
  handleDelete(index) {
    this.$confirm(' 是否进行删除操作?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.skuSendNumList1.splice(index, 1);
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
  // 物流配送方式选择 变更后暂无操作
  changeLineOffRadio(val) {}
  // 发货量验证
  enterInput(event, num0) {
    const eventNow = event.target.value;
    if (isNaN(event.target.value)) {
      this.$message({
        message: '请输入数字',
        type: 'error',
      });
      this.getDetailed(this.orderId);
      return;
    } else {
      if (eventNow <= 0 || parseInt(eventNow) != parseFloat(eventNow)) {
        this.$message({
          message: '请输入正确的值',
          type: 'error',
        });
        this.getDetailed(this.orderId);
        return;
      }
      if (num0 < eventNow) {
        this.$message({
          message: '本次发货量不可大于待发货量',
          type: 'error',
        });
        this.getDetailed(this.orderId);
      } else {
        return;
      }
    }
  }
  //下拉框数据收集
  getValue(val) {
    this.commitForm.companyName = val.split('/')[0];
    this.commitForm.companyCode = val.split('/')[1];
  }
  // 发货商品删除
  deleteDeliveryGoods(index) {
    this.$confirm(' 是否进行删除操作?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.skuSendNumList.splice(index, 1);
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
  //发货
  async save() {
    try {
      //收集数据
      this.skuSendNumList.forEach((item: any) => {
        const skuId = item.skuId;
        const num = Number(item.undeliveredNum);
        // 去重校验
        this.commitForm.skuSendNumList = this.commitForm.skuSendNumList.filter((item) => {
          return item.skuId !== skuId;
        });
        this.commitForm.skuSendNumList.push({ skuId, num });
      });
      // 收集订单ID
      this.commitForm.orderId = this.orderId;
      let form = this.commitForm
      if(this.logisticsInfoType == '1') {
        delete form.companyCode
        delete form.companyName
        delete form.num
      }
      
      // 非空校验
      for (const key in form) {
        if (!form[key]) {
          this.alertStatus = true;
          return;
        }
      }
      // 商品非空校验
      if (!this.commitForm.skuSendNumList.length) {
        this.alertStatus = true;
        return;
      }
      // 发货提交表单
      const cForm = {
        logisticsCompanyCode: this.commitForm.companyCode,
        logisticsCompanyName: this.commitForm.companyName,
        logisticsNo: this.commitForm.num,
        orderId: this.commitForm.orderId,
        skuSendNumList: this.commitForm.skuSendNumList,
        logisticsInfoType: this.logisticsInfoType
      };
      const result = await orderProcessingSuccess(cForm);
      if (result) {
        this.$message({
          message: '恭喜，您的订单已发货',
          type: 'success',
        });
        (this as any).$refs.drawer.closeDrawer();
      }
      this.commitForm = {
        companyCode: '',
        companyName: '',
        num: '',
        orderId: '',
        skuSendNumList: [],
      };
      this.logisticsInfoType = '0'
      this.getList(this.data);
    } catch (error) {
      this.commitForm = {
        companyCode: '',
        companyName: '',
        num: '',
        orderId: '',
        skuSendNumList: [],
      };
      this.getList(this.data);
      console.log(error);
    }
  }
  // 缺货
  create() {
    console.log('缺货');
    this.outOfStockLoading = true;
    const loading = this.$loading({
      lock: true,
      spinner: '',
      background: 'rgba(0, 0, 0, 0.5)',
    });

    const data = {
      orderId: this.orderId,
      skuSendNumList: this.skuSendNumList1,
      businessType: this.businessType,
    };

    createdStockoutOrder(data)
      .then((res) => {
        this.$message({
          message: '新建成功',
          type: 'success',
        });
        this.outStockDrawer = false;
        this.getList(this.data);
      })
      .catch((error) => {
        this.getList(this.data);
        this.$message.error(error);
      })
      .finally(() => {
        loading.close();
        this.outOfStockLoading = false;
      });
  }
  //取消抽屉顶部警告弹窗
  alertClose() {
    this.alertStatus = false;
  }
  //取消按钮
  cancel() {
    (this as any).$refs.drawer.closeDrawer();
  }
  //抽屉关闭的回调
  closeDrawer() {
    this.alertStatus = false;
    this.commitForm = this.form;
  }
  //订单导出
  async excelUpdata() {
    try {
      const downKey = (await orderUploadExcel())['downKey'];
      if (downKey) {
        this.loading = true;
        this.getExport(downKey);
      } else {
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
      this.$message.error(error);
    }
  }
  // 订单下载轮询
  getExport(downKey) {
    orderOutExcel({ downFileKey: downKey })
      .then((e) => {
        if (e.data.state == 3) {
          const down = document.createElement('a');
          down.href = e.data.downUrl;
          down.id = 'downId';
          document.body.appendChild(down);
          (document.getElementById('downId') as any).click();
          down.remove();
          down.remove();
          this.loading = false;
          this.$message({
            message: '导出成功',
            type: 'success',
          });
        } else if (e.data.state == 1) {
          // 实现轮询
          this.loading = true;
          const timer = setInterval(() => {
            this.getExport(downKey);
            clearInterval(timer);
          }, 3000);
        } else {
          this.loading = false;
          this.$message({
            message: '导出数据失败',
            type: 'warning',
          });
        }
      })
      .catch((error) => {
        this.loading = false;
        console.log(error);
        this.$message.error(error);
      });
  }
}
